import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import ScheduledMessage from '@/data/models/domain/scheduled/ScheduledMessage'
import type { SingleModelResolverParams } from '@/services/resolvers/types'
import { AppModule } from '@/config/types'
import ScheduledSmsDetailsResolver from '@/components/resolvers/ScheduledSmsDetailsResolver.vue'

export const scheduledDetailsRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.details,
  path: 'details/:messageId',
  props: true,
  meta: {
    tabTitle: 'pageTabTitle.user.scheduled.details',
    fullHeight: true,
    detailsPage: {
      source: 'router',
      requestParam: 'messageId',
      model: ScheduledMessage,
    } as SingleModelResolverParams,
    redirectToIfNotFound: { name: ScheduledRoutes.scheduled },
    redirectToIfAccessError: { name: ScheduledRoutes.scheduled },
    titler: {
      service: 'RouteTitlerService',
    },
    resolvers: [
      {
        service: 'ScheduledDetailsResolverService',
      },
    ],
    resolverComponent: ScheduledSmsDetailsResolver,
    modules: [
      AppModule.ScheduledDetails,
      AppModule.ScheduledNotSent,
      AppModule.ContactList,
      AppModule.SentSmsBase,
      AppModule.RecentRecipient,
      AppModule.Recipient,
    ],
  },
  component: () => import('@/components/views/scheduled/ScheduledDetailsSms.vue'),
}
